<template>
  <bm-overlay
    ref="customOverlay"
    :class="{ sample: true, active }"
    pane="labelPane"
    @draw="draw"
  >
    <slot name="text" />
  </bm-overlay>
</template>

<script>
export default {
  props: ['text', 'position', 'active'],
  watch: {
    position: {
      handler () {
        this.$refs.customOverlay.reload();
      },
      deep: true,
    },
  },
  methods: {
    draw ({ el, BMap, map }) {
      const { lng, lat } = this.position;
      const pixel = map.pointToOverlayPixel(new BMap.Point(lng, lat));
      el.style.left = pixel.x - 90 + 'px';
      el.style.top = pixel.y + 10 + 'px';
    },
  },
};
</script>

<style>
.sample {
  width: 180px;
  background: rgba(255, 255, 255, 0.8);
  box-shadow: 0 0 5px #000;
  overflow: hidden;
  text-align: center;
  padding: 4px;
  position: absolute;
}
</style>
